(function () {
    'use strict';

    /**
     * Registration (tickets and prices) section - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_Registration.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "registrationSection"
     * and still sees the page "vm" (getStyle, showLoading, addParamsToLink).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionRegistration', sectionRegistration);

    function sectionRegistration() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionRegistrationCtrl,
            controllerAs: 'registrationSection'
        };
    }

    SectionRegistrationCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionRegistrationCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        vm.tickets = [];

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Load the ticket groups (tickets, tariffs and prices) of the event
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise<boolean>} true when data was received
         */
        function load(eventId, lang) {
            return ApiFactory.GetTickets(eventId, lang).then(function (response) {
                if (response.data == null)
                    return false;

                vm.tickets = response.data;
                return true;
            });
        }
    }
})();
